<div id="root-element">
    <div id="tool-bar">
        <div id="map-image-tools">
            <input #backgroundFileInput 
                   hidden
                   (change)="newBackgroundFileSelected($event)"  
                   type="file" 
                   accept="image/jpeg">
            <button mat-button
                   *ngIf="!isCropping && !hasBackgroundImage"
                    (click)="backgroundFileInput.click()"
                    color="accent"
                    matTooltip="Als Kartenausschnitt kann eine beliebige PNG oder JPG Datei mit einer maximalen Größe von {{maxBackgroundFileSizeInKb}} KB ausgewählt werden.">
                <mat-icon>add</mat-icon>
                BILD AUSWÄHLEN
            </button>
            <button mat-button
                    *ngIf="!isReadonly && !isCropping && hasBackgroundImage"
                    (click)="backgroundFileInput.click()"
                    color="accent"
                    matTooltip="Als Kartenausschnitt kann eine beliebige PNG oder JPG Datei mit einer maximalen Größe von {{maxBackgroundFileSizeInKb}} KB ausgewählt werden.">
                <mat-icon>perm_media</mat-icon>
                BILD AUSWÄHLEN
            </button>
            <button mat-button
                    id="delete-drawing-button"
                    *ngIf="isReadyForDrawing" color="accent"
                    style="position: absolute; right: 0;"
                    [disabled]="isReadonly || !hasDrawElements" 
                    (click)="clearDrawing()">
                <mat-icon>delete</mat-icon>
                ZEICHNUNG LÖSCHEN
            </button>
            
            <button mat-button 
                    *ngIf="isCropping"
                    (click)="endCropping()"
                    color="accent" >
                <mat-icon>clear</mat-icon>
                ABBRECHEN
            </button>
            <button mat-button
                    style="position: absolute; right: 0;"
                    *ngIf="isCropping"
                    (click)="setBackgroundImage()"
                    color="accent">
                <mat-icon>done</mat-icon>
                AUSSCHNITT ÜBERNEHMEN
            </button>
        </div>
        
        <div id="edit-tools">
            <button mat-icon-button 
                    *ngIf="isReadonly"
                    (click)="delete()"
                    color="accent">
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button 
                    *ngIf="isReadonly"
                    (click)="startEdit()"
                    color="accent">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!isReadonly" color="accent" (click)="discardChanges()">
              <mat-icon>clear</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!isReadonly" [disabled]="!isReadyForDrawing" color="accent" (click)="saveChanges()">
              <mat-icon>done</mat-icon>
            </button>
        </div>
    </div>
    <div id="main-content">
        <div id=image-region>
            <canvas #locationSetupCanvas 
                    id="location-setup-canvas"
                    (dragover)="onDragOver($event)" 
                    (drop)="onDrop($event)">
            </canvas>
            <image-cropper #imageCropper
                           id="image-cropper"
                           *ngIf="isCropping"
                           (imageCropped)="backgroundImageCropped($event)"
                           [imageChangedEvent]="backgroundFileSelectedEvent" 
                           [maintainAspectRatio]="true" 
                           [aspectRatio]="1 / 1"
                           format="jpeg">
            </image-cropper>
        </div>
        
        <div id="legend-region">
            <mat-list #legend class="legen-list">
                <div id="cable-legend">
                    <mat-button-toggle-group [(value)]="strokeStyle"
                                             [disabled]="isReadonly"
                                             vertical="true"
                                             class="width-100">
                        <mat-button-toggle #csCable value="cadetblue">
                            <mat-list-item>
                                <div [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                                     [style.border-top]="defalutLineWidth * (scaleSlider.value || scaleFactor) + 'px solid ' + csCable.value"
                                     class="legend-item-icon"></div>
                                <mat-label class="legend-item-label">Verbindungskabel</mat-label>
                            </mat-list-item>
                        </mat-button-toggle>
                        <mat-button-toggle #emuCable value="orange">
                            <mat-list-item>
                                <div [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                                     [style.border-top]="defalutLineWidth * (scaleSlider.value || scaleFactor) + 'px solid ' + emuCable.value"
                                     class="legend-item-icon"></div>
                                <mat-label class="legend-item-label">Netzanschlusskabel</mat-label>
                            </mat-list-item>
                        </mat-button-toggle>
                        <mat-button-toggle #mvCable value="red">
                            <mat-list-item>
                                <div [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                                     [style.border-top]="defalutLineWidth * (scaleSlider.value || scaleFactor) + 'px solid ' + mvCable.value"
                                     class="legend-item-icon"></div>
                                <mat-label class="legend-item-label">Mittelspg.-Kabel</mat-label>
                            </mat-list-item>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <mat-list-item>
                    <div class="draggable-element" [class.active-draggable-element]="!isReadonly">
                        <div [draggable]="!isReadonly" 
                            (dragstart)="onDragStart($event)"
                            [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                            [style.height]="20 * (scaleSlider.value || scaleFactor) +'px'"
                            style="background-color: firebrick;"
                            class="legend-item-icon"></div>
                    </div>
                    <mat-label class="legend-item-label">Zähleranschluss</mat-label>
                </mat-list-item> 
                <mat-list-item>
                    <div class="draggable-element" [class.active-draggable-element]="!isReadonly"style="vertical-align: middle; display: inline-block;">
                        <div [draggable]="!isReadonly" 
                            (dragstart)="onDragStart($event)"
                            [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                            [style.height]="20 * (scaleSlider.value || scaleFactor) +'px'"
                            style="background-color: darkcyan;"
                            class="legend-item-icon"></div>
                    </div>
                    <mat-label class="legend-item-label">Ladestation</mat-label>
                </mat-list-item>
                <mat-list-item>
                    <div class="draggable-element" [class.active-draggable-element]="!isReadonly"style="vertical-align: middle; display: inline-block;">
                        <div [draggable]="!isReadonly" 
                            (dragstart)="onDragStart($event)"
                            [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                            [style.height]="20 * (scaleSlider.value || scaleFactor) +'px'"
                            style="background-color: skyblue"
                            class="legend-item-icon"></div>
                    </div>
                    <mat-label class="legend-item-label">Wallbox</mat-label>
                </mat-list-item> 
                <mat-list-item>
                    <div class="draggable-element" [class.active-draggable-element]="!isReadonly"style="vertical-align: middle; display: inline-block;">
                        <div [draggable]="!isReadonly" 
                            (dragstart)="onDragStart($event)"
                            [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                            [style.height]="20 * (scaleSlider.value || scaleFactor) +'px'"
                            style="background-color: black"
                            class="legend-item-icon"></div>
                    </div>
                    <mat-label class="legend-item-label">Trafostation</mat-label>
                </mat-list-item> 
                <mat-list-item>
                    <div class="draggable-element" [class.active-draggable-element]="!isReadonly"style="vertical-align: middle; display: inline-block;">
                        <div [draggable]="!isReadonly" 
                            (dragstart)="onDragStart($event)"
                            [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                            [style.height]="20 * (scaleSlider.value || scaleFactor) +'px'"
                            style="background-color: forestgreen"
                            class="legend-item-icon"></div>
                    </div>
                    <mat-label class="legend-item-label">PV-Anlage</mat-label>
                </mat-list-item> 
                <mat-list-item>
                    <div class="draggable-element" [class.active-draggable-element]="!isReadonly"style="vertical-align: middle; display: inline-block;">
                        <div [draggable]="!isReadonly" 
                            (dragstart)="onDragStart($event)"
                            [style.width]="40 * (scaleSlider.value || scaleFactor) +'px'"
                            [style.height]="20 * (scaleSlider.value || scaleFactor) +'px'"
                            style="background-color: goldenrod"
                            class="legend-item-icon"></div>
                    </div>
                    <mat-label class="legend-item-label">Batteriespeicher </mat-label>
                </mat-list-item>
            </mat-list>
            
            <div id="scaling">
                <mat-label class="mat-header-cell" style="position: absolute; bottom: 36px;">Skalierungsfaktor: {{scaleSlider.value || scaleFactor}}</mat-label>
                <mat-slider #scaleSlider 
                            [disabled]="!isReadyForDrawing"
                            [max]="1.5"
                            [min]="0.5"
                            [step]="0.1"
                            [(value)]="scaleFactor"
                            class="width-100">
                </mat-slider>
            </div>
            <div id="legend-region-overlay" *ngIf="!hasBackgroundImage"></div>
        </div>
    </div>
</div>


